import React from "react";

import Badge from "components/Badge";

interface SideLoadedBusinessValidityRendererProps {
  value?: "Valid" | "Invalid" | null;
}

export function SideLoadedBusinessValidityRenderer({
  value,
}: SideLoadedBusinessValidityRendererProps) {
  // A group row has no record of its own to validate.
  if (!value) {
    return null;
  }

  if (value === "Valid") {
    return <Badge color="successGreen">Valid</Badge>;
  }

  return <Badge color="inputError">Invalid</Badge>;
}
